import { CssBaseline, FormControl, FormHelperText, Grid, TextField, Tooltip } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/lab';
import PropTypes from 'prop-types';
import _ from "lodash/fp";
import useStyles from '../../CommonStyle/CommonStyle';
import { FormattedMessage } from 'react-intl';

const PartChangeTypeCombo = (props) => {
    const classes = useStyles();
    const { comboProperty, control, errors, comboValue, setComboValue, processMasterValue } = props;
    const PcnTypeValue = [
        { id: 1, value: 'EOL', displayName: 'EOL' },
        { id: 2, value: 'PCN', displayName: 'PCN' },
    ];

    return (
        <React.Fragment>
            <CssBaseline />
            {comboProperty.isHookFormType && (<Grid item xs={12} sm={12} md={12} lg={12}>
                <FormControl fullWidth>
                    <Controller
                        render={({
                            field: { onChange } }) => (
                            <Autocomplete
                                fullWidth
                                onChange={(event, newValue) => {
                                    //resetComboValueForInOut()
                                    onChange(newValue)
                                    if (typeof newValue === 'string') {
                                        if (newValue != null) {
                                            setComboValue({
                                                newValue,
                                            });
                                        }

                                    } else if (newValue && newValue.inputValue) {
                                        // Create a new value from the user input
                                        setComboValue({
                                            title: newValue.inputValue,
                                        });
                                    } else if (newValue !== null) {
                                        setComboValue(newValue);

                                    } else if (newValue === null) {
                                        setComboValue('')

                                    } else {
                                        setComboValue(newValue);

                                    }
                                }}
                                loadingText="Loading..."
                                selectOnFocus
                                handleHomeEndKeys
                                value={comboValue.value || null}
                                autoHighlight
                                options={PcnTypeValue}

                                getOptionLabel={(option) => {
                                    if (typeof option === 'string') {
                                        return option;
                                    }
                                    if (option.inputValue) {
                                        return option.inputValue;

                                    }

                                    return option.value;
                                }}

                                getoptionselected={(option, value) => option.value === value}
                                disabled={comboProperty.isDisabled}
                                sx={{ width: 130 }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        required={comboProperty.isRequired === true ? true : false}
                                        autoFocus={comboProperty.isAutofocus}
                                        name={comboProperty.name}
                                        size='medium'
                                        label={comboProperty.label}
                                        error={comboProperty.errors}
                                        variant={comboProperty.variant}
                                        InputLabelProps={{
                                            shrink: true,
                                            classes: {
                                                asterisk: classes.asterisk
                                            }
                                        }}

                                    />

                                )}

                            />

                        )}

                        name={comboProperty.name}
                        rules={{ required: comboProperty.isRequired }}
                        control={control}
                        defaultValue={{ id: 0, displayName: '' }}
                    />
                    {comboProperty.isDisabled}
                    <div className={classes.error}>
                        {_.get(`${comboProperty.name}.type`, errors) === "required" && (
                            <FormHelperText className={classes.error}>{comboProperty.label} <FormattedMessage id="textfield.error.isrequirededmessage" defaultMessage="is required" /></FormHelperText>
                        )}
                    </div>
                </FormControl>

            </Grid>)}

            {!comboProperty.isHookFormType && (<Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: "3px" }}>
                <FormControl fullWidth>
                    <Autocomplete
                        fullWidth
                        openOnFocus={true}
                        onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {
                                if (newValue != null) {
                                    setComboValue({
                                        newValue,
                                    });
                                }

                            } else if (newValue && newValue.inputValue) {
                                // Create a new value from the user input
                                setComboValue({
                                    title: newValue.inputValue,
                                });
                            } else if (newValue !== null) {
                                setComboValue(newValue);

                            } else if (newValue === null) {
                                setComboValue('')

                            } else {
                                setComboValue(newValue);

                            }
                        }}
                        selectOnFocus
                        handleHomeEndKeys
                        value={comboValue.value || null}
                        autoHighlight
                        options={PcnTypeValue}
                        getOptionLabel={(option) => {

                            if (typeof option === 'string') {
                                return option;

                            }
                            if (option.inputValue) {
                                return option.inputValue;

                            }
                            return option.value;
                        }}
                        getoptionselected={(option, value) => option.value === value}
                        disabled={comboProperty.isDisabled}
                        sx={{ width: 150 }}
                        renderInput={params => (

                            <Tooltip title={comboValue.value || ''}>

                                <TextField
                                    {...params}
                                    autoFocus={comboProperty.isAutofocus}
                                    name={comboProperty.name}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size='medium'
                                    // label={(comboProperty.isRequired ? ' *' : '')}
                                    variant={comboProperty.variant}
                                />
                            </Tooltip>
                        )}
                    />
                </FormControl>
            </Grid>)}
        </React.Fragment>
    );
};

PartChangeTypeCombo.propTypes = {
    comboProperty: PropTypes.object.isRequired,
    control: PropTypes.any.isRequired,
    errors: PropTypes.any.isRequired,
    comboValue: PropTypes.any.isRequired,
    setComboValue: PropTypes.func.isRequired
};

export default PartChangeTypeCombo;



